import React, { useEffect, useState } from "react";
import { useCommonStats, useAccountStats } from "./helper/useStats";
import Countdown, { zeroPad } from "react-countdown";
// import { useWeb3React } from "@web3-react/core";
import dateFormat from "dateformat";
import { supportNetwork } from "../../../hooks/network";
import Button from "react-bootstrap-button-loader";
import { formatPrice, getWeb3Contract } from "../../../hooks/contractHelper";
import poolAbi from "../../../json/presalePool.json";
import ERC20Abi from "../../../json/ERC20.json";
import { parseEther } from "ethers/lib/utils";
import { toast } from "react-toastify";
import { getWeb3 } from "../../../hooks/connectors";
import { getContract } from "../../../hooks/contractHelper";
import ReactPlayer from "react-player/youtube";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useLocation } from "react-router-dom";
import { contract } from "../../../hooks/constant";
import { AiFillEdit } from "react-icons/ai";
import { formatAddress } from "../../../utils/helper";
import question from "../../../images/question.png"
import { useNetwork, useAccount } from "wagmi";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default function ProjectDetails() {
  const [updater, setUpdater] = useState(1);
  const stats = useCommonStats(updater);
  const accStats = useAccountStats(updater);
  const [currentTime] = useState(Math.floor(new Date().getTime() / 1000.0));
  const [social, setSocial] = useState({});
  // const { chain?.id, account, library } = useWeb3React();
  const {chain} = useNetwork()
  const {address} = useAccount()
  const [amount, setAmount] = useState(0);
  const [allowance, setAllowance] = useState(0);
  const [btndisabled, setBtndisabled] = useState(false);
  const [error_msg, setError_msg] = useState("");
  const [loading, setLoading] = useState(false);
  const [waddloading, setWaddloading] = useState(false);
  const [finalLoading, setFinalLoading] = useState(false);
  const [wcLoading, setWcLoading] = useState(false);
  const [ctLoading, setCtLoading] = useState(false);
  const [locklLoading, setLocklLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [refcopy1, setRefcopy1] = useState(false);
  const [refcopy2, setRefcopy2] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [unsetmodalShow, setUnsetmodalShow] = useState(false);
  const [editmodalShow, setEditmodalShow] = useState(false);
  const [whitelistAddress, setWhitelistAddress] = useState("");
  const [removeWhitelistAddress, setRemoveWhitelistAddress] = useState("");
  const search = useLocation().search;
  const queryChainId = new URLSearchParams(search).get("chainId");
  const [error, setError] = useState({
    logourl: "",
    bannerurl: "",
    website: "",
    facebook: "",
    twitter: "",
    github: "",
    telegram: "",
    instagram: "",
    discord: "",
    reddit: "",
    youtube: "",
    brief: "",
  });

  const [editSocial, setEditSocial] = useState({
    logourl: "",
    bannerurl: "",
    website: "",
    facebook: "",
    twitter: "",
    github: "",
    telegram: "",
    instagram: "",
    discord: "",
    reddit: "",
    youtube: "",
    brief: "",
  });

  const [isValidLogoUrl, setIsValidLogoUrl] = useState(true);
  const [isValidBannerUrl, setIsValidBannerUrl] = useState(true);
  const explorerLink = "https://build.steamexchange.io/address/"
  function handleClick(location) {
    window.location.href = explorerLink+location
  }
  const handleLoadLogo = () => {
    setIsValidLogoUrl(true);
  };

  const handleErrorLogo = () => {
    setIsValidLogoUrl(false);
  };
  const handleLoadBanner = () => {
    setIsValidBannerUrl(true);
  };

  const handleErrorBanner = () => {
    setIsValidBannerUrl(false);
  };

  useEffect(() => {
    function getDetails() {
      let details = stats.poolDetails.toString().split("$#$");
      const object = {
        logourl: details[0],
        bannerurl: details[1],
        website: details[2],
        blockstar: details[3],
        facebook: details[4],
        twitter: details[5],
        github: details[6],
        telegram: details[7],
        instagram: details[8],
        discord: details[9],
        reddit: details[10],
        youtube: details[11],
        brief: details[12],
      };

      setSocial(object);
      setEditSocial(object);
    }
    if (stats) {
      getDetails();
    }
  }, [stats]);

  const startTime = new Date(stats.startTime * 1000);
  const endTime = new Date(stats.endTime * 1000);

  const checkValidation = (input, inputValue) => {
    let terror = 0;
    let message = "";
    var reg;
    switch (input) {
      case "facebook":
      case "twitter":
      case "github":
      case "telegram":
      case "instagram":
      case "discord":
      case "reddit":
      case "youtube":
      case "blockstart":
        reg = new RegExp(
          /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi
        );
        if (inputValue !== "" && !reg.test(inputValue)) {
          terror += 1;
          message = "Please Enter Valid url!";
        } else {
          message = "";
        }
        break;

      case "logourl":
      case "bannerurl":
      case "website":
        reg = new RegExp(
          /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi
        );
        if (!reg.test(inputValue)) {
          terror += 1;
          message = "Please Enter Valid url!";
        } else {
          message = "";
        }
        break;
      default:
        terror += 0;
        break;
    }

    if (terror > 0) {
      setError({ ...error, [input]: message });
      return false;
    } else {
      setError({ ...error, [input]: "" });
      return true;
    }
  };

  const checkAllValidation = () => {
    let terror = 0;
    var reg;
    Object.keys(editSocial).map((key, index) => {
      switch (key) {
        case "facebook":
        case "twitter":
        case "github":
        case "telegram":
        case "instagram":
        case "discord":
        case "reddit":
        case "youtube":
        case "blockstart":
          reg = new RegExp(
            /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi
          );
          if (editSocial[key] !== "" && !reg.test(editSocial[key])) {
            terror += 1;
          }

          break;

        case "logourl":
        case "bannerurl":
        case "website":
          reg = new RegExp(
            /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi
          );
          if (!reg.test(editSocial[key])) {
            terror += 1;
          }

          break;
        default:
          terror += 0;
          break;
      }
      return true;
    });

    if (terror > 0) {
      return false;
    } else {
      return true;
    }
  };

  const onChangeInput = (e) => {
    e.preventDefault();
    checkValidation(e.target.name, e.target.value);
    setEditSocial({ ...editSocial, [e.target.name]: e.target.value });
  };

  const handleEditSubmit = async (e) => {
    let check = checkAllValidation();
    if (check) {
      e.preventDefault();
      setEditLoading(true);
      try {
        if (address) {
          let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);
          let detailsset = `${editSocial.logourl}$#$${editSocial.bannerurl}$#$${editSocial.website}$#$$#$${editSocial.facebook}$#$${editSocial.twitter}$#$${editSocial.github}$#$${editSocial.telegram}$#$${editSocial.instagram}$#$${editSocial.discord}$#$${editSocial.reddit}$#$${editSocial.youtube}$#$${editSocial.brief}`;
          let tx = await poolContract.methods.updatePoolDetails(detailsset, {
            from: address,
          });
          const resolveAfter3Sec = new Promise((resolve) =>
            setTimeout(resolve, 5000)
          );
          toast.promise(resolveAfter3Sec, {
            pending: "Waiting for confirmation",
          });

          var interval = setInterval(async function () {
            let web3 = getWeb3(chain?.id);
            var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
            if (response != null) {
              clearInterval(interval);
              if (response.status === true) {
                toast.success("success! your last transaction was successful 👍");
                setUpdater(new Date());
                setEditLoading(false);
                setEditmodalShow(false);
              } else if (response.status === false) {
                toast.error("error ! Your last transaction failed.");
                setUpdater(new Date());
                setEditLoading(false);
              } else {
                toast.error("error ! something went wrong.");
                setUpdater(new Date());
                setEditLoading(false);
              }
            }
          }, 5000);
        } else {
          toast.error("Please Connect your wallet !");
          setEditLoading(false);
        }
      } catch (err) {
        toast.error(err.reason ? err.reason : err.message);
        setEditLoading(false);
      }
    } else {
      toast.error(
        "Required all field or Enter wrong value  ! please check again"
      );
    }
  };

  const countdownrender = ({ days, hours, minutes, seconds, completed }) => {
    const numberStyle = { color: 'white' };
    const letterStyle = { color: '#d28a1e', marginLeft: '2px' };
    const listStyle = { display: 'flex', alignItems: 'center', margin: '0 5px' };
  
    if (completed) {
      return (
        <ul style={{ listStyleType: 'none', padding: 0, margin: 0, display: 'flex', justifyContent: 'center' }}>
          <li style={listStyle}>
          <span style={letterStyle}>&nbsp;D&nbsp;:&nbsp;</span>
            <span style={numberStyle}>00</span>
            
          </li>
          <li style={listStyle}>
           <span style={letterStyle}>&nbsp;H&nbsp;:&nbsp;</span>
            <span style={numberStyle}>00</span>
            
          </li>
          <li style={listStyle}>
            <span style={letterStyle}>&nbsp;M&nbsp;:&nbsp;</span>
            <span style={numberStyle}>00</span>
            
          </li>
          <li style={listStyle}>
            <span style={letterStyle}>&nbsp;S&nbsp;:&nbsp;</span>
            <span style={numberStyle}>00</span>
            
          </li>
        </ul>
      );
    } else {
      return (
        <ul style={{ listStyleType: 'none', padding: 0, margin: 0, display: 'flex', justifyContent: 'center' }}>
          <li style={listStyle}>
            <span style={letterStyle}>&nbsp;D&nbsp;:&nbsp;</span>
            <span style={numberStyle}>{zeroPad(days, 2)}</span>
            
          </li>
          <li style={listStyle}>
            <span style={letterStyle}>&nbsp;H&nbsp;:&nbsp;</span>
            <span style={numberStyle}>{zeroPad(hours, 2)}</span>
            
          </li>
          <li style={listStyle}>
            <span style={letterStyle}>&nbsp;M&nbsp;:&nbsp;</span>
            <span style={numberStyle}>{zeroPad(minutes, 2)}</span>
            
          </li>
          <li style={listStyle}>
            <span style={letterStyle}>&nbsp;S&nbsp;:&nbsp;</span>
            <span style={numberStyle}>{zeroPad(seconds, 2)}</span>
            
          </li>
        </ul>
      );
    }
  };
  

  const handleChangeAmount = (e) => {
    setAmount(e.target.value);
    setBtndisabled(true);

    if (isNaN(e.target.value)) {
      setError_msg("please enter valid amount");
      setBtndisabled(true);
    } else if (parseFloat(e.target.value) === 0 || e.target.value === "") {
      setError_msg("amount must be greater than zero");
      setBtndisabled(true);
    } else if (
      parseFloat(e.target.value) < parseFloat(stats.minContribution) ||
      parseFloat(e.target.value) > parseFloat(stats.maxContribution)
    ) {
      setError_msg(
        `amount must be between ${stats.minContribution} and ${stats.maxContribution}`
      );
      setBtndisabled(true);
    } else {
      setError_msg("");
      setBtndisabled(false);
    }
    return;
  };

  const handleMaxAmount = (e) => {
    e.preventDefault();
    let maxamount =
      stats.currencyAddress === "0x0000000000000000000000000000000000000000"
        ? parseFloat(accStats.balance) - parseFloat(0.01)
        : parseFloat(accStats.balance);
    if (
      parseFloat(maxamount) < parseFloat(stats.minContribution) ||
      parseFloat(maxamount) > parseFloat(stats.maxContribution)
    ) {
      setError_msg(
        `amount must be between ${stats.minContribution} and ${stats.maxContribution}`
      );
      setBtndisabled(true);
    }
    setAmount(maxamount.toFixed(4).toString());
  };

  const handleSubmitContribution = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (
        amount > 0 &&
        (parseFloat(stats.maxContribution) > parseFloat(amount) ||
          parseFloat(stats.minContribution) < parseFloat(amount))
      ) {
        if (address) {
          if (chain?.id) {
            if (parseFloat(accStats.balance) >= parseFloat(amount)) {
              let poolContract = getWeb3Contract(
                poolAbi,
                stats.poolAddress,
                // library
              );

              let tokenAmount =
                stats.currencyAddress ===
                "0x0000000000000000000000000000000000000000"
                  ? 0
                  : parseEther(amount);
              let ethAmount =
                stats.currencyAddress ===
                "0x0000000000000000000000000000000000000000"
                  ? parseEther(amount)
                  : 0;

              let tx = await poolContract.methods.contribute(tokenAmount).send({
                from: address,
                value: ethAmount,
              });
              const resolveAfter3Sec = new Promise((resolve) =>
                setTimeout(resolve, 5000)
              );
              toast.promise(resolveAfter3Sec, {
                pending: "Waiting for confirmation 👌",
              });

              var interval = setInterval(async function () {
                let web3 = getWeb3(chain?.id);
                var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
                if (response != null) {
                  clearInterval(interval);
                  if (response.status === true) {
                    toast.success(
                      "success! your last transaction was successful 👍"
                    );
                    setUpdater(new Date());
                    setLoading(false);
                  } else if (response.status === false) {
                    toast.error("error ! Your last transaction failed.");
                    setUpdater(new Date());
                    setLoading(false);
                  } else {
                    toast.error("error ! something went wrong.");
                    setUpdater(new Date());
                    setLoading(false);
                  }
                }
              }, 5000);
            } else {
              toast.error("you don't have enough balance !");
              setLoading(false);
            }
          } else {
            toast.error("Please select Rails Network  or Rails Testnet !");
            setLoading(false);
          }
        } else {
          toast.error("Please Connect your Wallet!");
          setLoading(false);
        }
      } else {
        toast.error("Please Enter Valid Amount !");
        setLoading(false);
      }
    } catch (err) {
      toast.error(err.reason);
      setLoading(false);
    }
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (address) {
        if (chain?.id) {
          let currencyContract = getWeb3Contract(
            ERC20Abi,
            stats.currencyAddress,
            // library
          );

          let amount = parseEther("1000000000000000000000000000").toString();
          let tx = await currencyContract.methods.approve(stats.poolAddress, amount).send({
            from: address,
          });
          const resolveAfter3Sec = new Promise((resolve) =>
            setTimeout(resolve, 5000)
          );
          toast.promise(resolveAfter3Sec, {
            pending: "Waiting for confirmation 👌",
          });

          var interval = setInterval(async function () {
            let web3 = getWeb3(chain?.id);
            var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
            if (response != null) {
              clearInterval(interval);
              if (response.status === true) {
                toast.success("success! your last transaction was successful 👍");
                setUpdater(new Date());
                setLoading(false);
                accStats.allowance = "1000000000000000000000000000";
                setAllowance(accStats.allowance);
              } else if (response.status === false) {
                toast.error("error ! Your last transaction failed.");
                setUpdater(new Date());
                setLoading(false);
              } else {
                toast.error("error ! something went wrong.");
                setUpdater(new Date());
                setLoading(false);
              }
            }
          }, 5000);
        } else {
          toast.error("Please select Rails Network  or Rails Testnet !");
          setLoading(false);
        }
      } else {
        toast.error("Please Connect your Wallet!");
        setLoading(false);
      }
    } catch (err) {
      toast.error(err.reason);
      setLoading(false);
    }
  };

  const handleWhitelistStatus = async (e) => {
    e.preventDefault();
    try {
    if (address) {
      if (chain?.id) {
        let whitelist_status = e.target.value === "1" ? true : false;

        let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);

        let tx = await poolContract.methods.setWhitelisting(whitelist_status).send({
          from: address,
        });
        const resolveAfter3Sec = new Promise((resolve) =>
          setTimeout(resolve, 5000)
        );
        toast.promise(resolveAfter3Sec, {
          pending: "Waiting for confirmation 👌",
        });

        var interval = setInterval(async function () {
          let web3 = getWeb3(chain?.id);
          var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
          if (response != null) {
            clearInterval(interval);
            if (response.status === true) {
              toast.success("success! your last transaction was successful 👍");
              setUpdater(new Date());
            } else if (response.status === false) {
              toast.error("error ! Your last transaction failed.");
              setUpdater(new Date());
            } else {
              toast.error("error ! something went wrong.");
              setUpdater(new Date());
            }
          }
        }, 5000);
      } else {
        toast.error("Please select Rails Network  or Rails Testnet !");
      }
    } else {
      toast.error("Please Connect your Wallet!");
    }

    }
    catch (err) {
        toast.error(err.reason);

    }
  };

  const handleSetWhitelist = async (e) => {
    e.preventDefault();
    setWaddloading(true);
    try {
      const waddress = whitelistAddress.split(/\r?\n/);
      if (waddress.length > 0) {
        if (address) {
          let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);

          let tx = await poolContract.methods.addWhitelistedUsers(waddress).send({
            from: address,
          });
          const resolveAfter3Sec = new Promise((resolve) =>
            setTimeout(resolve, 5000)
          );
          toast.promise(resolveAfter3Sec, {
            pending: "Waiting for confirmation 👌",
          });

          var interval = setInterval(async function () {
            let web3 = getWeb3(chain?.id);
            var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
            if (response != null) {
              clearInterval(interval);
              if (response.status === true) {
                toast.success("success! your last transaction was successful 👍");
                setUpdater(new Date());
                setWaddloading(false);
              } else if (response.status === false) {
                toast.error("error ! Your last transaction failed.");
                setUpdater(new Date());
                setWaddloading(false);
              } else {
                toast.error("error ! something went wrong.");
                setUpdater(new Date());
                setWaddloading(false);
              }
            }
          }, 5000);
        } else {
          toast.error("Please Connect your wallet !");
          setWaddloading(false);
        }
      } else {
        toast.error("Please Enter Valid Addess !");
        setWaddloading(false);
      }
    } catch (err) {
      toast.error(err.reason ? err.reason : err.message);
      setWaddloading(false);
    }
  };

  const handleRemoveWhitelist = async (e) => {
    e.preventDefault();
    setWaddloading(true);
    try {
      const waddress = removeWhitelistAddress.split(/\r?\n/);
      if (waddress.length > 0) {
        if (address) {
          let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);

          let tx = await poolContract.methods.removeWhitelistedUsers(waddress).send({
            from: address,
          });
          const resolveAfter3Sec = new Promise((resolve) =>
            setTimeout(resolve, 5000)
          );
          toast.promise(resolveAfter3Sec, {
            pending: "Waiting for confirmation 👌",
          });

          var interval = setInterval(async function () {
            let web3 = getWeb3(chain?.id);
            var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
            if (response != null) {
              clearInterval(interval);
              if (response.status === true) {
                toast.success("success! your last transaction was successful 👍");
                setUpdater(new Date());
                setWaddloading(false);
              } else if (response.status === false) {
                toast.error("error ! Your last transaction failed.");
                setUpdater(new Date());
                setWaddloading(false);
              } else {
                toast.error("error ! something went wrong.");
                setUpdater(new Date());
                setWaddloading(false);
              }
            }
          }, 5000);
        } else {
          toast.error("Please Connect your wallet !");
          setWaddloading(false);
        }
      } else {
        toast.error("Please Enter Valid Addess !");
        setWaddloading(false);
      }
    } catch (err) {
      toast.error(err.reason ? err.reason : err.message);
      setWaddloading(false);
    }
  };

  const handleFinalize = async (e) => {
    e.preventDefault();
    setFinalLoading(true);
    try {
      if (address) {
        let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);

        let tx = await poolContract.methods.finalize().send({
          from: address,
        });
        const resolveAfter3Sec = new Promise((resolve) =>
          setTimeout(resolve, 5000)
        );
        toast.promise(resolveAfter3Sec, {
          pending: "Waiting for confirmation",
        });

        var interval = setInterval(async function () {
          let web3 = getWeb3(chain?.id);
          var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
          if (response != null) {
            clearInterval(interval);
            if (response.status === true) {
              toast.success("success! your last transaction was successful 👍");
              setUpdater(new Date());
              setFinalLoading(false);
            } else if (response.status === false) {
              toast.error("error ! Your last transaction failed.");
              setUpdater(new Date());
              setFinalLoading(false);
            } else {
              toast.error("error ! something went wrong.");
              setUpdater(new Date());
              setFinalLoading(false);
            }
          }
        }, 5000);
      } else {
        toast.error("Please Connect your wallet !");
        setFinalLoading(false);
      }
    } catch (err) {
      toast.error(err.reason ? err.reason : err.message);
      setFinalLoading(false);
    }
  };

  const handleWithdrawContribution = async (e) => {
    e.preventDefault();
    setWcLoading(true);
    try {
      if (address) {
        let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);

        let tx = await poolContract.methods.withdrawContribution().send({
          from: address,
        });
        const resolveAfter3Sec = new Promise((resolve) =>
          setTimeout(resolve, 5000)
        );
        toast.promise(resolveAfter3Sec, {
          pending: "Waiting for confirmation",
        });

        var interval = setInterval(async function () {
          let web3 = getWeb3(chain?.id);
          var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
          if (response != null) {
            clearInterval(interval);
            if (response.status === true) {
              toast.success("success! your last transaction was successful 👍");
              setUpdater(new Date());
              setWcLoading(false);
            } else if (response.status === false) {
              toast.error("error ! Your last transaction failed.");
              setUpdater(new Date());
              setWcLoading(false);
            } else {
              toast.error("error ! something went wrong.");
              setUpdater(new Date());
              setWcLoading(false);
            }
          }
        }, 5000);
      } else {
        toast.error("Please Connect your wallet !");
        setWcLoading(false);
      }
    } catch (err) {
      toast.error(err.reason ? err.reason : err.message);
      setWcLoading(false);
    }
  };

  const handleClaimToken = async (e) => {
    e.preventDefault();
    setCtLoading(true);
    try {
      if (address) {
        let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);

        let tx = await poolContract.methods.claim().send({
          from: address,
        });
        const resolveAfter3Sec = new Promise((resolve) =>
          setTimeout(resolve, 5000)
        );
        toast.promise(resolveAfter3Sec, {
          pending: "Waiting for confirmation",
        });

        var interval = setInterval(async function () {
          let web3 = getWeb3(chain?.id);
          var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
          if (response != null) {
            clearInterval(interval);
            if (response.status === true) {
              toast.success("success! your last transaction was successful 👍");
              setUpdater(new Date());
              setCtLoading(false);
            } else if (response.status === false) {
              toast.error("error ! Your last transaction failed.");
              setUpdater(new Date());
              setCtLoading(false);
            } else {
              toast.error("error ! something went wrong.");
              setUpdater(new Date());
              setCtLoading(false);
            }
          }
        }, 5000);
      } else {
        toast.error("Please Connect your wallet !");
        setCtLoading(false);
      }
    } catch (err) {
      toast.error(err.reason ? err.reason : err.message);
      setCtLoading(false);
    }
  };

  const handleWithdrawLiquidity = async (e) => {
    e.preventDefault();
    setLocklLoading(true);
    try {
      if (address) {
        let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);

        let tx = await poolContract.methods.withdrawLiquidity().send({
          from: address,
        });
        const resolveAfter3Sec = new Promise((resolve) =>
          setTimeout(resolve, 5000)
        );
        toast.promise(resolveAfter3Sec, {
          pending: "Waiting for confirmation",
        });

        var interval = setInterval(async function () {
          let web3 = getWeb3(chain?.id);
          var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
          if (response != null) {
            clearInterval(interval);
            if (response.status === true) {
              toast.success("success! your last transaction was successful 👍");
              setUpdater(new Date());
              setLocklLoading(false);
            } else if (response.status === false) {
              toast.error("error ! Your last transaction failed.");
              setUpdater(new Date());
              setLocklLoading(false);
            } else {
              toast.error("error ! something went wrong.");
              setUpdater(new Date());
              setLocklLoading(false);
            }
          }
        }, 5000);
      } else {
        toast.error("Please Connect your wallet !");
        setLocklLoading(false);
      }
    } catch (err) {
      toast.error(err.reason ? err.reason : err.message);
      setLocklLoading(false);
    }
  };

  const handleCancel = async (e) => {
    e.preventDefault();
    setLocklLoading(true);
    try {
      if (address) {
        let poolContract = getWeb3Contract(poolAbi, stats.poolAddress);

        let tx = await poolContract.methods.cancel().send({
          from: address,
        });
        const resolveAfter3Sec = new Promise((resolve) =>
          setTimeout(resolve, 5000)
        );
        toast.promise(resolveAfter3Sec, {
          pending: "Waiting for confirmation",
        });

        var interval = setInterval(async function () {
          let web3 = getWeb3(chain?.id);
          var response = await web3.eth.getTransactionReceipt(tx.transactionHash);
          if (response != null) {
            clearInterval(interval);
            if (response.status === true) {
              toast.success("success! your last transaction was successful 👍");
              setUpdater(new Date());
              setLocklLoading(false);
            } else if (response.status === false) {
              toast.error("error ! Your last transaction failed.");
              setUpdater(new Date());
              setLocklLoading(false);
            } else {
              toast.error("error ! something went wrong.");
              setUpdater(new Date());
              setLocklLoading(false);
            }
          }
        }, 5000);
      } else {
        toast.error("Please Connect your wallet !");
        setLocklLoading(false);
      }
    } catch (err) {
      toast.error(err.reason ? err.reason : err.message);
      setLocklLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="container mt-3 detail-page">
        <section className="item-details-area">
          <div className="row">
            <div className="col-12 col-md-8">
              <div className="px-2 py-4 card project-card no-hover">
                <div className="row">
                  {social.logourl && isValidLogoUrl && <div className="text-center col-12 col-md-2">
                      <img
                        className="mt-1 card-img-top avatar-max-lg "
                        width="100%"
                        height="auto"
                        src={social.logourl}
                        onLoad={handleLoadLogo}
                        onError={handleErrorLogo}
                        alt="iconimage12"
                      />
                    </div>}
                    {!isValidLogoUrl && <div className="text-center col-12 col-md-2">
                      <img
                        className="mt-1 card-img-top avatar-max-lg "
                        width="100%"
                        height="auto"
                        src={question}
                        alt="iconimage12"
                      />
                    </div>}
                  <div className="col-12 col-md-10">
                    <div className="row align-items-center justify-content-md-start justify-content-center">
                      <h4 className="mt-1 mb-2 text-center text-md-left">
                        {stats.tokenName} Presale
                      </h4>
                      <div className="gap-1 d-flex justify-content-center audit-status">
                        {stats.audit &&
                          (stats.auditStatus ||
                            (stats.auditLink && (
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={stats.auditLink}
                              >
                                <h4 className="text-center tag-btn text-uppercase bg-yellow">
                                  Audit
                                </h4>
                              </a>
                            )))}
                        {/* {stats.kyc &&
                          (stats.kycStatus ||
                            (stats.kycLink && (
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={stats.kycLink}
                              >
                                <h4 className="text-center tag-btn text-uppercase bg-purple">
                                  KYC
                                </h4>
                              </a>
                            )))} */}
                      </div>
                    </div>
                    <div className="social-share d-flex justify-content-center justify-content-md-start">
                      <ul className="d-flex list-unstyled">
                        {social.twitter && (
                          <li>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={social.twitter}
                            >
                              <i className="fab fa-twitter"></i>
                            </a>
                          </li>
                        )}
                        {social.telegram && (
                          <li>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={social.telegram}
                            >
                              <i className="fab fa-telegram"></i>
                            </a>
                          </li>
                        )}
                        {social.website && (
                          <li>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={social.website}
                            >
                              <i className="fas fa-globe"></i>
                            </a>
                          </li>
                        )}
                        {social.discord && (
                          <li>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={social.discord}
                            >
                              <i className="fab fa-discord"></i>
                            </a>
                          </li>
                        )}
                        {social.facebook && (
                          <li>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={social.facebook}
                            >
                              <i className="fab fa-facebook"></i>
                            </a>
                          </li>
                        )}
                        {social.github && (
                          <li>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={social.github}
                            >
                              <i className="fab fa-github"></i>
                            </a>
                          </li>
                        )}

                        {social.instagram && (
                          <li>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={social.instagram}
                            >
                              <i className="fab fa-instagram"></i>
                            </a>
                          </li>
                        )}

                        {social.reddit && (
                          <li>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={social.reddit}
                            >
                              <i className="fab fa-reddit"></i>
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                    <p className="text-center text-md-left">
                      {editSocial.brief}
                    </p>
                  </div>
                </div>
                <div className="mt-5 row">
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Presale Address</p>
                    <a href={explorerLink + stats.poolAddress} target="_blank" rel="noreferrer" style={{cursor: "pointer"}}>
                        {formatAddress(stats.poolAddress)}
                        <CopyToClipboard
                          text={stats.poolAddress}
                          onCopy={() => {
                            setRefcopy1(true);
                            setTimeout(() => {
                              setRefcopy1(false);
                            }, 2000);
                          }}
                        >
                          <img
                            className="ml-2"
                            src={require("../../../images/icon.png")}
                            alt="project"
                          />
                        </CopyToClipboard>
                        <span>{refcopy1 && "copied"}</span>
                    </a>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Token Name</p>
                    <p>{stats.tokenName}</p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Token Symbol</p>
                    <p>{stats.tokenSymbol}</p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Token Decimals</p>
                    <p>{stats.tokenDecimal}</p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Token Address</p>
                    <a href={explorerLink + stats.token} target="_blank" rel="noreferrer" style={{cursor: "pointer"}}>
                        {formatAddress(stats.token)}
                        <CopyToClipboard
                          text={stats.token}
                          onCopy={() => {
                            setRefcopy2(true);
                            setTimeout(() => {
                              setRefcopy2(false);
                            }, 2000);
                          }}
                        >
                          <img
                            className="ml-2"
                            src={require("../../../images/icon.png")}
                            alt="project"
                          />
                        </CopyToClipboard>
                        <span>{refcopy2 && "copied"}</span>
                      </a>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Total Supply</p>
                    <p>
                      {formatPrice(stats.tokenSupply)} {stats.tokenSymbol}
                    </p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Presale Rate </p>
                    <p>
                      1 {stats.currencySymbol} = {formatPrice(stats.rate)}{" "}
                      {stats.tokenSymbol}
                    </p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Listing Rate </p>
                    <p>
                      1 {stats.currencySymbol} ~{" "}
                      {formatPrice(stats.liquidityListingRate)}{" "}
                      {stats.tokenSymbol}
                    </p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Soft Cap </p>
                    <p>
                      {stats.softCap} {stats.currencySymbol}
                    </p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Hard Cap </p>
                    <p>
                      {stats.hardCap} {stats.currencySymbol}
                    </p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Unsold Tokens </p>
                    <p>{stats.refundType === "0" ? "Refund" : "Burn"}</p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Presale Start Time </p>
                    <p>{dateFormat(startTime, "yyyy-mm-dd HH:MM")}</p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Presale End Time </p>
                    <p>{dateFormat(endTime, "yyyy-mm-dd HH:MM")}</p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Listing On </p>
                    <p>
                      {contract[queryChainId]
                        ? contract[queryChainId].routername
                        : contract[chain?.id]
                        ? contract[chain?.id].routername
                        : contract["default"].routername}
                    </p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Liquidity Percent </p>
                    <p>{stats.liquidityPercent} %</p>
                  </div>
                  <div className="my-2 col-12 d-flex justify-content-between">
                    <p>Liquidity Unlocked Time </p>
                    <p>{parseFloat(stats.liquidityLockDays) / 60} minutes</p>
                  </div>
                </div>
                <div className="presale-status">
                  {stats.poolState === "1" ? (
                    <h4 className="text-center tag-btn text-uppercase bg-completed">
                      Completed
                    </h4>
                  ) : stats.poolState === "2" ? (
                    <h4 className="text-center tag-btn text-uppercase bg-cancelled">
                      Cancelled
                    </h4>
                  ) : parseInt(stats.endTime) <
                    Math.floor(new Date().getTime() / 1000.0) ? (
                    <h4 className="text-center tag-btn text-uppercase bg-ended">
                      Ended
                    </h4>
                  ) : parseInt(stats.startTime) >
                    Math.floor(new Date().getTime() / 1000.0) ? (
                    <h4 className="text-center tag-btn text-uppercase bg-upcoming">
                      Upcoming
                    </h4>
                  ) : parseInt(stats.startTime) <
                      Math.floor(new Date().getTime() / 1000.0) &&
                    parseInt(stats.endTime) >
                      Math.floor(new Date().getTime() / 1000.0) ? (
                    <h4 className="text-center tag-btn text-uppercase bg-active">
                      Active
                    </h4>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="card project-card no-hover">
                {isValidBannerUrl && (
                  <div className="banner-container">
                    <img
                      className="banner-image"
                      src={social.bannerurl}
                      onLoad={handleLoadBanner}
                      onError={handleErrorBanner}
                      alt="banner"
                    />
                  </div>
                )}
                <div className="card-body">
                  <div className="mt-3 mt-md-0 d-flex justify-content-center">
                    <div className="countdown">
                      <div
                        className="text-center"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {parseInt(stats.endTime) <
                        Math.floor(new Date().getTime() / 1000.0)
                          ? "Presale Ended"
                          : parseInt(stats.startTime) >
                            Math.floor(new Date().getTime() / 1000.0)
                          ? "Presale Starts In"
                          : parseInt(stats.startTime) <
                              Math.floor(new Date().getTime() / 1000.0) &&
                            parseInt(stats.endTime) >
                              Math.floor(new Date().getTime() / 1000.0)
                          ? "Presale Ends In"
                          : ""}
                      </div>
                      <Countdown
                        key={Math.floor(Math.random() * 10 + 1)}
                        date={
                          stats.startTime > currentTime
                            ? stats.startTime * 1000
                            : stats.endTime * 1000
                        }
                        renderer={countdownrender}
                      />
                    </div>
                  </div>
                  <div className="item-progress">
                    <div className="mb-1 progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${parseFloat(stats.percentageRaise).toFixed(2)}%`,
                        }}
                        aria-valuenow={parseFloat(stats.percentageRaise).toFixed(2)}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <span className="progress-text">
                          {parseFloat(stats.percentageRaise).toFixed(2)}%
                        </span>
                      </div>
                    </div>
                    <div className="progress-sale d-flex justify-content-between">
                      <span>0 {stats.currencySymbol}</span>
                      <span>
                        {stats.hardCap} {stats.currencySymbol}
                      </span>
                    </div>
                  </div>
                  <div className="mt-4 staking-area">
                    <div className="staking-card single-staking">
                      <p>Amount</p>
                      <div className="my-1 input-box">
                        <div className="input-area d-flex flex-column">
                          <div className="input-text">
                            <input
                              type="text"
                              value={amount}
                              onChange={(e) => {
                                handleChangeAmount(e);
                              }}
                              placeholder="0.00"
                            />
                            <a
                              href="#sec"
                              onClick={(e) => {
                                handleMaxAmount(e);
                              }}
                            >
                              Max
                            </a>
                          </div>
                          <div className="mt-2">
                            {stats.currencyAddress ===
                              "0x0000000000000000000000000000000000000000" ||
                            accStats.allowance > 0 ||
                            allowance > 0 ? (
                              <Button
                                variant="none"
                                disabled={btndisabled}
                                loading={loading}
                                type="button"
                                onClick={(e) => {
                                  handleSubmitContribution(e);
                                }}
                                className="btn-negative"
                              >
                                SUBMIT
                              </Button>
                            ) : (
                              <Button
                                variant="none"
                                loading={loading}
                                type="button"
                                onClick={(e) => {
                                  handleApprove(e);
                                }}
                                className="btn-negative"
                              >
                                Approve
                              </Button>
                            )}
                          </div>
                        </div>
                        <span className="text-danger">
                          <small>{error_msg}</small>
                        </span>
                      </div>
                      {(stats.poolState === "2" || stats.poolState === "0") && (
                        <React.Fragment>
                          <p className="mt-4">Your Contribution</p>
                          <span className="mt-0 mb-3">
                            {accStats.contributionOf
                              ? formatPrice(accStats.contributionOf)
                              : "0"}{" "}
                            {stats.currencySymbol}
                          </span>
                        </React.Fragment>
                      )}
                      {/* <div className="mb-3 input-area d-flex flex-column flex-md-row"> */}
                      {stats.poolState === "1" && (
                        <React.Fragment>
                          <p className="mb-15">Your Claimable Tokens</p>
                          <span className="mt-0 mb-3">
                            {accStats.userAvalibleClaim
                              ? formatPrice(accStats.userAvalibleClaim)
                              : "0"}{" "}
                            {stats.tokenSymbol}
                          </span>
                          <Button
                            loading={ctLoading}
                            variant="none"
                            className="mt-2 btn input-btn mt-md-0 mr-md-3"
                            onClick={(e) => handleClaimToken(e)}
                          >
                            Claim Token
                          </Button>
                        </React.Fragment>
                      )}
                      {accStats.contributionOf > 0 &&
                        (stats.poolState === "2" ||
                          stats.poolState === "0") && (
                          <>
                            <Button
                              loading={wcLoading}
                              className="mt-4 btn input-btn mt-md-0 mr-md-3"
                              onClick={(e) => handleWithdrawContribution(e)}
                            >
                              Withdraw Contribution
                            </Button>
                            <small className="text-danger font-weight-bold">
                              *10% penalty for early withdrawal.
                            </small>
                          </>
                        )}
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card project-card no-hover">
                <div className="card no-hover staking-card single-staking">
                  <div className="mb-2 d-flex justify-content-between">
                    <p>Sale Type</p>
                    <p>Presale</p>
                  </div>
                  <div className="mb-2 d-flex justify-content-between">
                    <p>Access type</p>
                    <p>{stats.useWhitelisting ? "Whitelist" : "Public"}</p>
                  </div>
                  <div className="mb-2 d-flex justify-content-between">
                    <p>Min. Allocation</p>
                    <p>
                      {stats.minContribution} {stats.currencySymbol}
                    </p>
                  </div>
                  <div className="mb-2 d-flex justify-content-between">
                    <p>Max. Allocation</p>
                    <p>
                      {stats.maxContribution} {stats.currencySymbol}
                    </p>
                  </div>
                </div>
              </div>
              <div className="card project-card no-hover staking-card single-staking">
                <div className="d-flex justify-content-between">
                  <h5 className="m-3">Admin Center</h5>
                  {stats.governance &&
                    address &&
                    stats.governance.toLowerCase() ===
                      address.toLowerCase() && (
                      <a
                        href="#sec"
                        onClick={(e) => setEditmodalShow(!editmodalShow)}
                      >
                        <AiFillEdit fill="black" />
                      </a>
                    )}
                </div>
                {stats.governance &&
                address &&
                stats.governance.toLowerCase() === address.toLowerCase() ? (
                  <React.Fragment>
                    <ul
                      className="my-3 border-0 nav nav-tabs staking-tabs my-md-4 justify-content-center"
                      role="tablist"
                    >
                      <li className="mr-1 nav-item" role="presentation">
                        <button
                          value="1"
                          onClick={(e) => handleWhitelistStatus(e)}
                          className={`btn tab-link ${
                            stats.useWhitelisting ? "active" : ""
                          }`}
                          href="#tab-one"
                          role="tab"
                        >
                          Whitelist Mode
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          value="2"
                          onClick={(e) => handleWhitelistStatus(e)}
                          className={`btn tab-link ${
                            stats.useWhitelisting ? "" : "active"
                          }`}
                          href="#tab-two"
                        >
                          Public Mode
                        </button>
                      </li>
                    </ul>

                    <div className="my-1 input-box">
                      <div className="mb-3 input-area d-flex justify-content-center flex-column flex-md-row">
                        <button
                          type="button"
                          className="mt-2 btn input-btn mt-md-0 ml-md-3"
                          onClick={(e) => setModalShow(!modalShow)}
                        >
                          Add users to whitelist
                        </button>
                        <button
                          type="button"
                          className="mt-2 btn input-btn mt-md-0 ml-md-3"
                          onClick={(e) => setUnsetmodalShow(!unsetmodalShow)}
                        >
                          Remove whitelist users
                        </button>
                      </div>
                    </div>
                    <div className="my-1 input-box">
                      <div className="mb-3 input-area d-flex justify-content-center flex-column flex-md-row">
                        {stats.poolState === "0" && (
                          <Button
                            variant="none"
                            loading={locklLoading}
                            onClick={(e) => handleCancel(e)}
                            type="button"
                            className="mt-2 btn btn-bordered-white mt-md-0 ml-md-3"
                          >
                            cancel
                          </Button>
                        )}
                        { stats.poolState === "0" &&
                          ((stats.totalRaised === stats.hardCap || parseFloat(stats.hardCap - stats.totalRaised) < parseFloat(stats.minContribution)) ||
                            (stats.totalRaised >= stats.softCap && Math.floor(new Date().getTime() / 1000.0) >= stats.endTime)) && 
                          (
                            <Button
                              variant="none"
                              type="button"
                              loading={finalLoading}
                              onClick={(e) => handleFinalize(e)}
                              className="mt-2 btn btn-bordered-white mt-md-0 ml-md-3"
                            >
                              Finalize
                            </Button>
                          )}
                        {stats.poolState === "1" &&
                          stats.liquidityUnlockTime <=
                            Math.floor(new Date().getTime() / 1000.0) && (
                            <Button
                              type="button"
                              loading={locklLoading}
                              onClick={(e) => handleWithdrawLiquidity(e)}
                              className="mt-2 btn btn-bordered-white mt-md-0 ml-md-3"
                            >
                              Withdraw Liquidity
                            </Button>
                          )}
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  <div className="d-flex justify-content-center">
                    <h5 className="my-4">You are not the owner of the pool</h5>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add users to whitelist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Control
                as="textarea"
                onChange={(e) => {
                  setWhitelistAddress(e.target.value);
                }}
                rows={8}
                placeholder="Insert address: One address per line, no commas required."
                value={whitelistAddress}
              />
            </Form.Group>
            <Button
              variant="none"
              className="btn"
              loading={waddloading}
              onClick={(e) => {
                handleSetWhitelist(e);
              }}
            >
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={unsetmodalShow}
        onHide={() => setUnsetmodalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Remove user from whitelist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Control
                as="textarea"
                onChange={(e) => {
                  setRemoveWhitelistAddress(e.target.value);
                }}
                rows={8}
                placeholder="Insert address: separate with breaks line."
                value={removeWhitelistAddress}
              />
            </Form.Group>
            <Button
              variant="none"
              className="btn btn-success"
              loading={waddloading}
              onClick={(e) => {
                handleRemoveWhitelist(e);
              }}
            >
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={editmodalShow}
        onHide={() => setEditmodalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>
                    Logo URL<span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    value={editSocial.logourl}
                    name="logourl"
                    placeholder="e.g. https://blockstar.site/pwa_image/blockstar_pwa.png"
                  />
                  <small className="text-danger">{error.logourl}</small>
                  <br />
                </div>
              </div>
              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>
                    Banner Image URL<span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    value={editSocial.bannerurl}
                    name="bannerurl"
                    placeholder="e.g. https://blockstar.site/pwa_image/blockstar_pwa.png"
                  />
                  <small className="text-danger">{error.bannerurl}</small>
                  <br />
                </div>
              </div>
              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>
                    Website*<span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    value={editSocial.website}
                    name="website"
                    placeholder="e.g. https://blockstar.site"
                  />
                  <small className="text-danger">{error.website}</small>
                  <br />
                </div>
              </div>
              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>Facebook</label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    value={editSocial.facebook}
                    name="facebook"
                    placeholder="e.g. https://www.facebook.com/"
                  />
                  <small className="text-danger">{error.facebook}</small>
                  <br />
                </div>
              </div>
              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>Twitter</label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    value={editSocial.twitter}
                    name="twitter"
                    placeholder="e.g. https://twitter.com/"
                  />
                  <small className="text-danger">{error.twitter}</small>
                  <br />
                </div>
              </div>

              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>Github</label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    value={editSocial.github}
                    name="github"
                    placeholder="e.g. https://github.com/"
                  />
                  <small className="text-danger">{error.github}</small>
                  <br />
                </div>
              </div>
              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>Telegram</label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    name="telegram"
                    value={editSocial.telegram}
                    placeholder="e.g. https://t.me/BlockStar_Social_Media"
                  />
                  <small className="text-danger">{error.telegram}</small>
                  <br />
                </div>
              </div>

              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>Instagram</label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    name="instagram"
                    value={editSocial.instagram}
                    placeholder="e.g. https://www.instagram.com/"
                  />
                  <small className="text-danger">{error.instagram}</small>
                  <br />
                </div>
              </div>
              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>Discord</label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    name="discord"
                    value={editSocial.discord}
                    placeholder="e.g. https://discord.com/"
                  />
                  <small className="text-danger">{error.discord}</small>
                  <br />
                </div>
              </div>

              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>Reddit</label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    name="reddit"
                    value={editSocial.reddit}
                    placeholder="e.g. https://reddit.com/"
                  />
                  <small className="text-danger">{error.reddit}</small>
                  <br />
                </div>
              </div>
              <div className="mb-0 col-md-6">
                <div className="form-group">
                  <label>Youtube Video</label>
                  <input
                    className="form-control"
                    onChange={(e) => onChangeInput(e)}
                    type="text"
                    name="youtube"
                    value={editSocial.youtube}
                    placeholder="e.g. https://www.youtube.com/watch?v=BHACKCNDMW8"
                  />
                  <small className="text-danger">{error.youtube}</small>
                  <br />
                </div>
              </div>

              <div className="mt-4 mb-0 col-md-12"></div>

              <div className="mt-4 mb-0 col-md-12 d-flex justify-content-center">
                <Button
                  className="btn-negative"
                  loading={editLoading}
                  onClick={(e) => handleEditSubmit(e)}
                >
                  submit
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
